import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverwriteTargetsWithMaterialNames = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.31043 12.1507H1.00011L1.00006 8.15075M6.31043 12.1507L11.6207 2.80645M6.31043 12.1507L15 7.32258L11.6207 2.80645M6.31043 12.1507L6.31038 8.15075M1.00006 8.15075H6.31038M1.00006 8.15075L1 4.5M11.6207 2.80645L6.31032 1M6.31038 8.15075L6.31032 4.5M6.31032 1H1V1.45162V4.5M6.31032 1V4.5M1 4.5H6.31032",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.0924 13.4245L2.90803 13.4241C2.95882 13.4244 3.00023 13.4584 3.00005 13.4999L2.99962 14.2493L5.67176 14.2493L5.68071 13.5974C5.681 13.5342 5.7712 13.4988 5.83105 13.5386L7.46483 14.6591C7.47584 14.6662 7.48472 14.6752 7.49082 14.6855C7.49692 14.6958 7.50005 14.7071 7.5 14.7185C7.49995 14.73 7.49671 14.7412 7.49053 14.7515C7.48434 14.7618 7.47537 14.7707 7.46431 14.7777L5.82156 15.8252C5.76022 15.8646 5.67148 15.8285 5.67176 15.7654L5.66988 15.1029L2.80888 15.0999C2.40146 15.0982 1.99862 14.8325 2.00009 14.5L1.99972 13.4994C1.9999 13.4579 2.04162 13.4243 2.0924 13.4245Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.05 11.917H15.8133C15.8408 11.917 15.8633 11.9545 15.8633 12.0003V13.1423C15.8633 13.1881 15.8408 13.2256 15.8133 13.2256H11.05C11.0225 13.2256 11 13.1881 11 13.1423V12.0003C11 11.9545 11.0225 11.917 11.05 11.917Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.13934 14.5H15.8203C15.8588 14.5 15.8903 14.5375 15.8903 14.5833V15.8094C15.8903 15.8553 15.8588 15.8928 15.8203 15.8928H9.13934C9.10084 15.8928 9.06934 15.8553 9.06934 15.8094V14.5833C9.06934 14.5375 9.10084 14.5 9.13934 14.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgOverwriteTargetsWithMaterialNames;
